import numeral from "numeral";

export default function(value, { percentFormat = "0.00%" }) {
  // Numeral converts 1 to 100%, so need to divide by 100
  return numeral(value / 100).format(percentFormat);
}
